<template>
  <div class="grid-wrap">
    <div class="grid-row">
      <article class="push__bottom">
        <div class="grid-col grid-col--soft grid-xsmall-12 grid-large-9 push__top">
            <BackLink/>
        </div>
        <Form :data="form"
          :error="$v.form.$error"
          :formId="id"
          :formErrorMessage="errorMessage"
          @submit="submitSection"
          :submitButtonText="buttonText">   
            <span class="caption-xl">{{subtitle}}</span>
            <h1 class="alpha push__bottom">{{title}}</h1>
            <Fieldset
                :title="'1. ' + question1.title"
                type="default">
                <div :class="['form-group', {'form-group--error' : $v.form.getalong.$error}]">
                    <span id="input-ex-getalong" class="error-message" v-if="$v.form.getalong.$error">Please select on of the following options below</span>
                    <div v-for="(option, index) in question1.answers" :key="'getalong' + index">
                        <RadioButton :label="option" name="getalong" :id="'getalong' + index" :value="index" :model="answer1" @change="changeQ1"/>
                    </div>
                </div>          
            </Fieldset>
            <div :class="[{'hidden' :  answer1 === null || answer1 === 0}]">            

                <Fieldset
                    :title="'2. ' +question2.title"
                    type="default">
                    <div :class="['form-group', {'form-group--error' : $v.form.difficulties.$error}]">
                        <span id="input-ex-difficulties" class="error-message" v-if="$v.form.difficulties.$error">Please select on of the following options below</span>
                        <div v-for="(option, index) in question2.answers" :key="'difficulties' + index">
                            <RadioButton :label="option" name="difficulties" :id="'difficulties' + index" :value="index" :model="answer2" @change="changeQ2"/>
                        </div>
                    </div>          
                </Fieldset>
                           
                <Fieldset
                    :title="'3. ' +question3.title"
                    type="default">
                    <div :class="['form-group', {'form-group--error' : $v.form.distress.$error}]">
                        <span id="input-ex-distress" class="error-message" v-if="$v.form.distress.$error">Please select on of the following options below</span>
                        <div v-for="(option, index) in question3.answers" :key="'distress' + index">
                            <RadioButton :label="option" name="distress" :id="'distress' + index" :value="index" :model="answer2" @change="changeQ3"/>
                        </div>
                    </div>          
                </Fieldset>                
                            
                <Fieldset :title="'4. '+question4.title" type="default">
                    
                    <div :class="['form-group', {'form-group--error' : $v.form.homelife.$error || $v.form.friendships.$error || $v.form.learning.$error || $v.form.leisure.$error}]">
                        <span id="input-ex-question-4" class="error-message" v-if="$v.form.homelife.$error || $v.form.friendships.$error || $v.form.learning.$error || $v.form.leisure.$error">
                        Please ensure that all 4 sections of this question are answered
                        </span>
                        <div class="grid-row push__bottom hide--small">
                            <div class="grid-col grid-xsmall-12 grid-medium-4 grid-large-4"></div>                        
                            <div class="grid-col grid-xsmall-12 grid-medium-2 grid-large-2 align-center" v-for="label in question4.answers" :key="label"> 
                                <span><strong>{{label}}</strong></span>
                            </div>
                        </div>

                        <div class="grid-row push__bottom">
                            <div class="bg__light-grey spacer push__bottom"></div>
                            <div class="form-group">
                                <div class="grid-col grid-xsmall-12 grid-medium-4 grid-large-4">
                                    <span class="heading-s block soft__right push__right"><strong>{{question4.labels[0]}}</strong></span>
                                </div>
                                <div class="grid-col grid-xsmall-12 grid-medium-2 grid-large-2 align-center" v-for="(a, index) in question4.answers" :key="'q41a' + index">
                                    <div class="inline-block">                                              
                                        <RadioButton 
                                            :label="a" 
                                            :hideLabel="true" 
                                            :name="'q41'" 
                                            :id="'q41-a' + index" 
                                            :value="index" 
                                            :model="answer41" 
                                            @change="changeQ41"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grid-row push__bottom">
                            <div class="bg__light-grey spacer push__bottom"></div>
                            <div :class="['form-group']">
                                <div class="grid-col grid-xsmall-12 grid-medium-4 grid-large-4">
                                    <span class="heading-s block soft__right push__right"><strong>{{question4.labels[1]}}</strong></span>
                                </div>
                                <div class="grid-col grid-xsmall-12 grid-medium-2 grid-large-2 align-center" v-for="(a, index) in question4.answers" :key="'q42a' + index">
                                    <div class="inline-block">                                              
                                        <RadioButton 
                                            :label="a" 
                                            :hideLabel="true" 
                                            :name="'q42'" 
                                            :id="'q42-a' + index" 
                                            :value="index" 
                                            :model="answer42" 
                                            @change="changeQ42"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grid-row push__bottom">
                            <div class="bg__light-grey spacer push__bottom"></div>
                            <div class="grid-col grid-xsmall-12 grid-medium-4 grid-large-4">
                                <span class="heading-s block soft__right push__right"><strong>{{question4.labels[2]}}</strong></span>
                            </div>
                            <div class="grid-col grid-xsmall-12 grid-medium-2 grid-large-2 align-center" v-for="(a, index) in question4.answers" :key="'q43a' + index">
                                <div class="inline-block">                                              
                                    <RadioButton 
                                        :label="a" 
                                        :hideLabel="true" 
                                        :name="'q43'" 
                                        :id="'q43-a' + index" 
                                        :value="index" 
                                        :model="answer43" 
                                        @change="changeQ43"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="grid-row push__bottom">
                            <div class="bg__light-grey spacer push__bottom"></div>                         
                            <div class="grid-col grid-xsmall-12 grid-medium-4 grid-large-4">
                                <span class="heading-s block soft__right push__right"><strong>{{question4.labels[3]}}</strong></span>
                            </div>
                            <div class="grid-col grid-xsmall-12 grid-medium-2 grid-large-2 align-center" v-for="(a, index) in question4.answers" :key="'q44a' + index">
                                <div class="inline-block">                                              
                                    <RadioButton 
                                        :label="a" 
                                        :hideLabel="true" 
                                        :name="'q44'" 
                                        :id="'q44-a' + index" 
                                        :value="index" 
                                        :model="answer44" 
                                        @change="changeQ44"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Fieldset>
           
                <Fieldset
                    :title="'5. ' +question5.title"
                    type="default">
                    <div :class="['form-group', {'form-group--error' : $v.form.burden.$error}]">
                        <span id="input-ex-burden" class="error-message" v-if="$v.form.burden.$error">Please select on of the following options below</span>
                        <div v-for="(option, index) in question5.answers" :key="'burden' + index">
                            <RadioButton :label="option" name="burden" :id="'burden' + index" :value="index" :model="answer2" @change="changeQ5"/>
                        </div>
                    </div>          
                </Fieldset>
            </div>
            
        </Form>        
      </article>
    </div>
  </div>
</template>

<script>

import { required, requiredIf } from "vuelidate/lib/validators";
import { dataService } from "../shared";

export default {
  name: "SectionOfQuestionsImpact",
  created() {
    this.loadQuestion();
  },
  mounted() {
      this.loadAnswer();
  },
  data() {
    return {
      id : "",
      title: "",
      content: "",
      destination: "",
      errorMessage: "Please ensure all questions are answered and valid.",      
      answer1: null,
      answer2: null, 
      answer3: null,
      answer41: null,
      answer42: null,
      answer43: null,
      answer44: null,
      answer5: null,
      form : {
        getalong: null,
        difficulties: null,
        distress: null,
        homelife: null,
        friendships: null,
        learning: null,
        leisure: null,
        burden : null
      }
    };
  },
    validations : {
        form : {
            getalong: {required},
            difficulties: {
                required: requiredIf(function() {
                    return this.answer1 !== 0;
                })
            },
            distress: {
                required: requiredIf(function() {
                    return this.answer1 !== 0;
                })
            },
            homelife: {
                required: requiredIf(function() {
                    return this.answer1 !== 0;
                })
            },
            friendships: {
                required: requiredIf(function() {
                    return this.answer1 !== 0;
                })
            },
            learning: {
                required: requiredIf(function() {
                    return this.answer1 !== 0;
                })
            },
            leisure: {
                required: requiredIf(function() {
                    return this.answer1 !== 0;
                })
            },
            burden : {
                required: requiredIf(function() {
                    return this.answer1 !== 0;
                })
            }
        }
    }, 
    

  methods: {    
    loadQuestion() {
      let json = dataService.getQuestions();
      let questions = json.questions;
      let currentQuestion = dataService.findElement(
        questions,
        dataService.parseUrl()
      );
      this.id = currentQuestion.id;
      this.title = currentQuestion.title;
      this.subtitle = currentQuestion.subtitle;
      this.buttonText = currentQuestion.buttonText;
      this.destination = currentQuestion.destination;
      this.question1 = currentQuestion.question1;
      this.question2 = currentQuestion.question2;
      this.question3 = currentQuestion.question3;
      this.question4 = currentQuestion.question4;
      this.question5 = currentQuestion.question5;
    },
    loadAnswer() {
        let previousResponse = dataService.wasAnsweredBefore(this.id);
        console.log(previousResponse);
        if (previousResponse) {
            var getAlongRadio = document.getElementById('getalong' + previousResponse.getalong);
            getAlongRadio.checked = true;
            this.changeQ1(previousResponse.getalong);

            if (previousResponse.getalong > 0) {
                var difficultiesRadio = document.getElementById('difficulties' + previousResponse.difficulties);
                difficultiesRadio.checked = true;
                this.changeQ2(previousResponse.difficulties);

                var distressRadio = document.getElementById('distress' + previousResponse.distress);
                distressRadio.checked = true;
                this.changeQ3(previousResponse.distress);

                var homelifeRadio = document.getElementById('q41-a' + previousResponse.homelife);
                homelifeRadio.checked = true;
                this.changeQ41(previousResponse.homelife);

                var friendshipsRadio = document.getElementById('q42-a' + previousResponse.friendships);
                friendshipsRadio.checked = true;
                this.changeQ42(previousResponse.friendships);

                var learningRadio = document.getElementById('q43-a' + previousResponse.learning);
                learningRadio.checked = true;
                this.changeQ43(previousResponse.learning);

                var leisureRadio = document.getElementById('q44-a' + previousResponse.leisure);
                leisureRadio.checked = true;
                this.changeQ44(previousResponse.leisure);

                var burdenRadio = document.getElementById('burden' + previousResponse.burden);
                burdenRadio.checked = true;
                this.changeQ5(previousResponse.burden);
            }
        }
    },
    changeQ1: function(newValue) {
        this.answer1 = newValue;
        this.form.getalong = newValue;
    },
    changeQ2: function(newValue) {
        this.answer2 = newValue;
        this.form.difficulties = newValue;
    },
    changeQ3: function(newValue) {
        this.answer3 = newValue;
        this.form.distress = newValue;
    },
    changeQ41: function(newValue) {
        this.answer41 = newValue;
        this.form.homelife = newValue;
    },
    changeQ42: function(newValue) {
        this.answer42 = newValue;
        this.form.friendships = newValue;
    },
    changeQ43: function(newValue) {
        this.answer43 = newValue;
        this.form.learning = newValue;
    },
    changeQ44: function(newValue) {
        this.answer44 = newValue;
        this.form.leisure = newValue;
    },
    changeQ5: function(newValue) {
        this.answer5 = newValue;
        this.form.burden = newValue;
    },
    logResponse() {
      let response = {
        id: this.id,
        questionType: "SectionOfQuestionsImpact",
        getalong: this.answer1,
        difficulties: this.answer2,
        distress: this.answer3,
        homelife: this.answer41,
        friendships: this.answer42,
        learning: this.answer43,
        leisure: this.answer44,
        burden : this.answer5
      };
      dataService.logResponse(response);
    },
    submitForm(form, valid) {
        valid.$touch();
        if (valid.$pending || valid.$error) {
            setTimeout(() => {
                document.querySelector(".error-summary__link").focus()
            }, 0);
            return;	
        }
        this.logResponse();
        this.$router.push({ name: this.destination.toLowerCase() });
    },
    submitSection() {
      this.submitForm(this.form, this.$v.form);
    },
    redirectToTimeout() {
      dataService.resetResponses();
      this.$router.push({ name: "timeout" });
    }
  }
};
</script>